/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-06 20:13:08
 * @Description: 后台-用户管理-角色管理
 */
'use strict';
angular.module("roleManagementModule", ["roleManagementServiceModule"]).
controller('roleManagementCtrl', ['$scope', '$state', 'httpService', 'roleManagementService', 'modalDialog', function($scope, $state, httpService, roleManagementService, modalDialog) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			inputData: '',
			rightType: 'oper',
			active: 'active'
		}
		$scope.data = {
			listData: [],
			operAuthorityTree: [], //操作权限树
			dataAuthorityTree: [], //数据权限树
			authorityValue: [], //权限位数组
			channelValue: [], //渠道ids
			classicsValue:[],//分类ids
			roleId: -1,
			roleName: ''
		};
	};
	$scope.isSelected = function(item) {
		var flag = false;
		if($scope.data.roleId == item.id) {
			flag = true;
		}
		return flag;
	}

	function initData() {
		requestData()
	};
	/**
	 * [requestData description] 初始化列表
	 * @return {[type]} [description]
	 */
	function requestData() {
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/list.do", '', "post").then(function(data) {
			$scope.data.listData = data.data.reverse();
			$scope.initAuthority($scope.data.listData[0]);
			$scope.page = {
				CURRPAGE: data.data.startPage,
				PAGESIZE: data.data.pageSize,
				ITEMCOUNT: data.data.totalResults,
				PAGECOUNT: data.data.totalPages
			};
		});
		/*
		 * 初始化权限树
		 */
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/auth/getAllRightIndexs.do", '', "post").then(function(data) {
			$scope.data.operAuthorityTree = data.data;
		});
		/*
		 * 初始化数据权限树
		 */
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/getRightChannels.do", '', "post").then(function(data) {
			$scope.data.dataAuthorityTree = {
				id: -1,
				channelName: '渠道',
				children: data.data
			}
		});
		/**
		 * 初始化分类权限树
		 */
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/classic/queryClassics.do", '', "post").then(function(data) {
			$scope.data.classicsAuthorityTree ={
				id:-1,
				classicsName:'UGC',
				children:data.data
			};
		});
	};
	/**
	 * [addRole description] 新建角色
	 * @return {[type]} [description]
	 */
	$scope.editRole = function(roleId, roleName) {
		roleManagementService.createRole(roleId, roleName).then(function(data) {
			$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/addEdit.do", data, "post").then(function(data) {
				requestData();
			});
		});
	}
	/**
	 * [addRole description]删除角色
	 * @return {[type]} [description]
	 */
	$scope.deleteRole = function(roleId) {
		modalDialog.backConfirmModal("删除", "确认删除当前选中的角色?", function() {
			$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/delete.do", {
				roleId: roleId
			}, "post").then(function(data) {
				requestData();
			});
		});
	}
	/**
	 * [userManagement description]用户管理
	 * @return {[type]} [description]
	 */
	$scope.userManagement = function() {
		$state.go("backstage.organization.rolemanagement.usermanagementforrole", {
			roleId: $scope.data.roleId,
			roleName: $scope.data.roleName
		});
	}

	/**
	 * [initAuthority description]根据角色查权限
	 * @return {[type]} [description]
	 */
	$scope.initAuthority = function(item) {
		$scope.data.roleId = item.id;
		$scope.data.roleName = item.roleName;
		initAuthority(item.id);
	}
	/*
	 * 加载角色所有的权限
	 */
	function initAuthority(id) {
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/findRoleRight.do", {roleId: id}, "post").then(function(data) {
			$scope.data.authorityValue = data.rightValue.split('');
			$scope.data.channelValue = data.channelIds;
			$scope.data.classicsValue = data.ugcClassicIds;
		});
	}
	/**
	 * [saveValue description]点击页面上的复选框选种植
	 * @return {[type]} [description]
	 */
	$scope.saveValue = function(item) {
		if($scope.data.roleId == -1) {
			modalDialog.alertType('', '请先选择角色', 'info')
			return;
		}
		var index = item.index;
		var a = $scope.data.authorityValue;
		var s = item.children;
		if(a[index] == 1) {
			a[index] = 0;
			if(s.length > 0) {
				for(var i = 0; i < s.length; i++) {
					a[s[i].index] = 0;
					var x = s[i].children;
					if(x.length > 0) {
						for(var j = 0; j < x.length; j++) {
							a[x[j].index] = 0;
						}
					}
				}
			}
		} else {
			a[index] = 1;
			if(s.length > 0) {
				for(var i = 0; i < s.length; i++) {
					a[s[i].index] = 1;
					var x = s[i].children;
					if(x.length > 0) {
						for(var j = 0; j < x.length; j++) {
							a[x[j].index] = 1;
						}
					}
				}
			}
		}
	}

	/**
	 * [saveAuthority description]保存用户权限
	 * @return {[type]} [description]
	 */
	$scope.saveAuthority = function() {
		var params = {
			roleId: $scope.data.roleId,
			rightValue: $scope.data.authorityValue.join(''),
			channelIds: $scope.data.channelValue.join(','),
			ugcClassicIds:$scope.data.classicsValue.join(',')
		}
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/role/saveRoleRight.do", params, "post").then(function(data) {
			modalDialog.alertType('', '保存权限成功', 'success')
			initAuthority($scope.data.roleId);
		});
	}
	/**
	 * [saveValueChannel description]保存用户数据权限
	 * @return {[type]} [description]
	 */
	$scope.saveValueChannel = function(cid) {
		if($scope.data.roleId == -1) {
			modalDialog.alertType('', '请先选择角色', 'info')
			return;
		}
		//全选的操作
		var dat = $scope.data.dataAuthorityTree; //渠道值存储成变量
		var cv = $scope.data.channelValue; //存储用户已选择的权限值
		if(cid == -1) {
			if(dat.children.length == cv.length) {
				$scope.data.channelValue = [];
			} else {
				$scope.data.channelValue = [];
				angular.forEach(dat.children, function(data, index, array) {
					$scope.data.channelValue.push(data.id+'');
				});
			}
		} else {
			if(cv.indexOf(cid) != -1) {
				cv.splice(cv.indexOf(cid), 1);
			} else {
				cv.push(cid);
			}
		}
	}
	/**
	 * [saveValueClassics description]保存用户分类权限
	 * @return {[type]} [description]
	 */
	$scope.saveValueClassics = function(cid){
		if($scope.data.roleId == -1) {
			modalDialog.alertType('', '请先选择角色', 'info')
			return;
		}
		//全选的操作
		var dat = $scope.data.classicsAuthorityTree; //分类值存储成变量
		var cv = $scope.data.classicsValue; //存储用户已选择的权限值
		if(cid == -1) {
			if(dat.children.length == cv.length) {
				$scope.data.classicsValue = [];
			} else {
				$scope.data.classicsValue = [];
				angular.forEach(dat.children, function(data, index, array) {
					$scope.data.classicsValue.push(data.id+'');
				});
			}
		} else {
			if(cv.indexOf(cid) != -1) {
				cv.splice(cv.indexOf(cid), 1);
			} else {
				cv.push(cid);
			}
		}
	}
}]);